export const OPERO_LOGOS = {
  /** SVG icon mark for sidebar/favicon */
  mark: "/opero.svg",
  /** Square logo PNG */
  logo: "/opero-logo.png",
  /** Full horizontal logo with wordmark */
  logoFull: "/opero-logo-full.png",
} as const;
